





























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import SubscribePlanSelection from "../subscribeplanselection.vue";
import { Action, Getter } from "vuex-class";
import { UserMeta, Team, UserPlan, AvailablePlan } from "../../types";

@Component({
  components: {
    SubscribePlanSelection
  }
})
export default class Subscribe extends Vue {
  @Action private fetchUserPlan!: () => any;
  @Getter private userPlan!: UserPlan;
  @Getter private userPlanLoading!: boolean;

  private created() {
    this.fetchUserPlan();
  }

  @Watch("userPlan")
  private onUserPlan() {
    if(this.userPlan && this.userPlan.enterprise) {
      if (this.$route.params.redirect) {
      this.$router.replace(this.$route.params.redirect);
      return;
    } else if (this.$route.query.redirect) {
      this.$router.replace(this.$route.query.redirect as string);
      return;
    }
    if (this.$route.query.app) {
      this.$router.push({ name: "learner" });
      return;
    }
      this.$router.push({ name: "home" });
    }
  }

  private joinTeam() {
    
      this.$router.push({
        name: "jointeam",
    });
  
  }
}
